import { useConfirmVaOrderMutation } from "../app/vaApi/vaApi";
import {
  normalizeConfirmResult,
  getVaInvoiceErrorMessage,
} from "../helpers/vaInvoiceUtils";

export function useConfirmVaOrder() {
  const [confirmOrder, state] = useConfirmVaOrderMutation();

  const confirm = async (payload) => {
    try {
      const result = await confirmOrder(payload).unwrap();
      return normalizeConfirmResult(result);
    } catch (err) {
      throw {
        ...err,
        data: {
          ...err?.data,
          message: getVaInvoiceErrorMessage(err, { confirm: true }),
        },
      };
    }
  };

  return {
    confirm,
    isSubmitting: state.isLoading,
    error: state.error,
    reset: state.reset,
  };
}
